import { render, staticRenderFns } from "./ReviewOrderValidation.vue?vue&type=template&id=3fff93d3"
import script from "./ReviewOrderValidation.vue?vue&type=script&lang=js"
export * from "./ReviewOrderValidation.vue?vue&type=script&lang=js"
import style0 from "./ReviewOrderValidation.vue?vue&type=style&index=0&id=3fff93d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports